<template>
  <div class="custom-select">
    <el-input :disabled="disabled" placeholder="请选择大区" style="border: none;" readOnly
      :value="value ? value.regionName : ''" @click.native="openModal"></el-input>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
// import request from '../../../../utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import Storage from '@/found/utils/storage';

export default {
  name: 'terList',
  props: {
    title: String,
    value: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    getValue: Function,
  },
  data() {
    return {};
  },
  components: {
    SelectConfig,
  },
  watch: {
    value: {
      handler(val) {
        console.log('cccc', val);
        if (val) {
          this.value = val;
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 新增弹窗
    openModal() {
      console.log(this.value);
      const params = {
        functionCode: 'region_list',
        noReset: true,
        paramData: {
          orgType: 'vp_area',
          enableStatus: '009',
        },
        data: [],
        selectionList: [],
        idKey: 'orgCode',
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },
    // 选择回调
    onGetSelect(val) {
      console.log('onGetSelect ~ val:', val);
      const terInfo = {
        regionCode: val[0].orgCode,
        regionName: val[0].orgName,
      };
      this.$emit('change', terInfo);
    },
    // 清除选择
    clearFn(e) {
      e.stopPropagation();
      this.$emit('change');
    },
    handleClose(item) {
      if (this.disabled) {
        return;
      }
      const data = this.value.filter(
        (v) => v.organizationCode !== item.organizationCode,
      );
      this.$emit('input', data);
    },
  },
};
</script>

<style lang="less" scoped>
.cost-select {
    position: relative;
    border: 1px solid #dddfe6;
    border-radius: 5px;
    padding: 5px;

    /deep/ .el-input__inner {
        padding-right: 30px;
    }

    .clear-icon {
        width: 25px;
        height: 100%;
        position: absolute;
        right: 5px;
        top: 0;
        text-align: center;
        color: #c0c4cc;
        transition: all 0.3s;
        padding-top: 1px;
        display: none;

        .el-icon-circle-close {
            width: 100%;
            font-size: 14px;
            cursor: pointer;
            transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
    }

    &:hover {
        .clear-icon {
            display: block;
        }
    }
}

.disabled-select {
    pointer-events: none;
    background: #f5f7fa;
}
</style>
